export const successAddReminderMessage = "اعلان با موفقیت ثبت شد.";
export const failedAddReminderMessage = "خطا در ثبت اعلان! دوباره تلاش کنید.";
